/**
 * `ActionButton` que também pode estar travado por uma regra do equipamento (fora de uso) (#363).
 * Um tooltip só: se falta a permissão, vale o motivo da permissão (o do próprio `ActionButton`);
 * com a permissão em dia, vale o motivo da trava. Embrulhar o `ActionButton` num segundo tooltip
 * deixaria os dois brigando pelo mesmo botão.
 */
import React from 'react';
import { Tooltip } from '@mui/material';

import { ActionButton, type ActionButtonProps } from '../../../components/common/ActionButton';
import { useAcao } from '../../../authorization/useVeredito';

export interface LockableActionButtonProps extends ActionButtonProps {
  /** Quando preenchido, o botão fica desabilitado e este texto é o motivo. */
  lockedReason?: string;
}

export const LockableActionButton: React.FC<LockableActionButtonProps> = ({
  lockedReason,
  disabled,
  ...props
}) => {
  const permission = useAcao(props.acao, props.rotulo, { modulo: props.modulo });

  if (!lockedReason || permission.disabled) return <ActionButton {...props} disabled={disabled || Boolean(lockedReason)} />;

  return (
    <Tooltip title={lockedReason}>
      <span>
        <ActionButton {...props} disabled />
      </span>
    </Tooltip>
  );
};

export default LockableActionButton;
